import { HelpEntry } from '../models/knowledge.model';

/**
 * DOCU-914: client-side search over the help entries. With ~20 entries a server
 * side search is not warranted; title, summary and tags are all the panel has
 * to offer anyway.
 */
export function filterHelpEntries(entries: HelpEntry[], term: string): HelpEntry[] {
  const needle = term.trim().toLowerCase();
  if (!needle) {
    return entries;
  }

  return entries.filter(entry => {
    const haystack = [
      entry.title,
      entry.summary,
      ...(entry.tags || []),
    ].join(' ').toLowerCase();

    return haystack.includes(needle);
  });
}
